/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {dlsAlt, dlsColor} from '../../theme/theme';

/**
 *  default buffer vertices value for initial square
 * for polygonal draw
 */
export const RECTANGULAR_GEOFENCE_INITIAL_BUFFER = 700000;

export const GEOFENCE_BUFFER_FACTORIAL = 1.75;

/**
 *  default unit of measure for creating shapes should
 *  we not have a value from the user's settings
 */
export const DEFAULT_UNIT = 'meters';

/**
 *  radius of the earth in kilometers
 */
export const EARTH_RADIUS = 6378.137;

/**
 * Default symbol data for geoFence graphics
 */
export const DEFAULT_SYMBOL = () => ({
  type    : 'simple-fill',
  style   : 'backward-diagonal',
  color   : dlsAlt('colors', 'geofenceBackground'),
  outline : {
    color : dlsColor('skyBlue'),
    width : 2
  }
});

/**
 * Defines constant for Generate events
 */
export const GENERATE_EVENTS_VALUE = 'Both (Enter & Exit)';

/**
 * Defines constant for non trigger event
 */
export const NONE_TRIGGER_EVENT = 'None (Landmark Only)';
